import Vue from 'vue'
import details from './details'
import address from './address'
import {createAndDownloadWorksheet} from 'src/utilities/excel'
import {assemblePlanNameDisplay, objectById} from 'src/utilities/utils'
import {getPlanNames, getCompanies, getLegalSubdivisions, getProjects} from 'src/utilities/ptracApiHelper'
import sanitizeHtml from 'sanitize-html'
import moment from 'moment'
import _ from 'lodash'
import {make} from 'vuex-pathify'

const initialState = {
  projectId: null,
  departments: [],
  expandAllDepartments: JSON.parse(localStorage.getItem('expandAllDepartments')) || false
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

mutations.reset = (state) => {
  state.projectId = null
  state.departments = []
}

mutations.setExpandAllDepartments = (state, value) => {
  state.expandAllDepartments = value
  localStorage.setItem('expandAllDepartments', JSON.stringify(value))
}

//TODO refactor getters to remove duplication
getters.departments = (state, getters, rootState) => {
  const kvps = []
  rootState.departments.results.forEach((department) => {
    if (department.active &&
      state.departments.includes(department.id)) {
      const kvp = {
        id: department.id,
        name: department.name
      }
      kvps.push(kvp)
    }
  })
  return kvps
}

getters.departmentsForSelect = (state, getters, rootState) => {
  const kvps = []
  rootState.departments.results.forEach((department) => {
    if (department.active &&
      state.departments.includes(department.id)) {
      const kvp = {
        value: department.id,
        label: department.name
      }
      kvps.push(kvp)
    }
  })
  return kvps
}

getters.departmentsGeneratePatch = (state) => {
  return {
    id: state.projectId,
    endpoint: 'projects',
    data: [
      { 'op': 'replace', 'path': '/departments', 'value': JSON.parse(JSON.stringify(state.departments)) }
    ]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async resultsToExcel({rootState}, jobs) {
      const dateVal = moment()
      const fileName = 'jobs-by-department-search-results' + dateVal.format('MM-DD-YYYY') + '.xlsx'
      const tabName = 'Jobs in Project by Department'
      const header = [{
        header: 'Project Name',
        key: 'projectName',
        width: 30
      }, {
        header: 'Project Active',
        key: 'projectActive',
        width: 30
      }, {
        header: 'Project Description',
        key: 'projectDescription',
        width: 30
      }, {
        header: 'Stop Work',
        key: 'stopWork',
        width: 30
      }, {
        header: 'Job Name',
        key: 'jobName',
        width: 30
      }, {
        header: 'Job File number',
        key: 'number',
        width: 30
      }, {
        header: 'Job Status',
        key: 'status',
        width: 30
      }, {
        header: 'Plan Name',
        key: 'planName',
        width: 30
      }, {
        header: 'Coordinator',
        key: 'coordinator',
        width: 30
      }, {
        header: 'Department',
        key: 'department',
        width: 30
      }, {
        header: 'City',
        key: 'city',
        width: 30
      }, {
        header: 'County',
        key: 'county',
        width: 30
      }, {
        header: 'State',
        key: 'state',
        width: 30
      }, {
        header: 'Jurisdiction',
        key: 'jurisdiction',
        width: 30
      }, {
        header: 'Legal Description',
        key: 'legalDescription',
        width: 30
      }, {
        header: 'Legal Subdivision',
        key: 'legalSubdivision',
        width: 30
      }, {
        header: 'Block Number',
        key: 'blockNumber',
        width: 30
      }, {
        header: 'Street Number',
        key: 'streetNumber',
        width: 30
      }, {
        header: 'Street Name',
        key: 'streetName',
        width: 30
      }, {
        header: 'Building Number',
        key: 'buildingNumber',
        width: 30
      }, {
        header: 'Floor Number',
        key: 'floorNumber',
        width: 30
      }, {
        header: 'Lot Number',
        key: 'lotNumber',
        width: 30
      }, {
        header: 'Suite Number',
        key: 'suiteNumber',
        width: 30
      }, {
        header: 'Zip',
        key: 'zip',
        width: 30
      }, {
        header: 'Phase',
        key: 'phase',
        width: 30
      }, {
        header: 'Section',
        key: 'section',
        width: 30
      }, {
        header: 'Community',
        key: 'community',
        width: 30
      }, {
        header: 'Builder Name',
        key: 'builder',
        width: 30
      }, {
        header: 'Client Name',
        key: 'client',
        width: 30
      }, {
        header: 'Created At',
        key: 'createdAt',
        width: 30
      }, {
        header: 'Created By',
        key: 'createdBy',
        width: 30
      }, {
        header: 'Updated At',
        key: 'updatedAt',
        width: 30
      }, {
        header: 'Updated By',
        key: 'updatedBy',
        width: 30
      }, {
        header: 'Date Received',
        key: 'dateReceived',
        width: 30
      }, {
        header: 'Target Completion Date',
        key: 'targetCompletionDate',
        width: 30
      }, {
        header: 'Actual Completion Date',
        key: 'actualCompletionDate',
        width: 30
      }, {
        header: 'Job Description',
        key: 'description',
        width: 30
      }, {
        header: 'Entity Type',
        key: 'entityType',
        width: 30
      }, {
        header: 'Invoice By',
        key: 'invoiceBy',
        width: 30
      }]

      const projects = await getProjects(jobs, 'projectId')
      const legalSubdivisions = await getLegalSubdivisions(projects, 'address.legalSubdivisionId')
      const planNames = await getPlanNames(jobs, 'planNameId')
      const companies = await getCompanies(jobs, 'clientId', 'builderId')

      const rows = []
      jobs.forEach((job) => {
        const coordinatorName = objectById(rootState.users.results, job.coordinatorId)
        const usernameJobCreated = objectById(rootState.users.results, job.createdBy)
        const usernameJobUpdated = objectById(rootState.users.results, job.updatedBy)
        const departmentName = objectById(rootState.departments.results, job.departmentId)
        const planName = objectById(planNames, job.planNameId)
        const builderName = objectById(companies, job.builderId)
        const clientName = objectById(companies, job.clientId)
        const project = objectById(projects, job.projectId)
        const legalSubdivision = objectById(legalSubdivisions, _.get(project, 'address.legalSubdivisionId'))

        const rule = {
          projectName: details.state.name,
          projectActive: details.state.active,
          projectType: details.state.projectType,
          stopWork: details.state.stopWork,
          jobName: job.name,
          number: job.number,
          status: job.status,
          city: address.state.city,
          county: address.state.county,
          state: address.state.state,
          jurisdiction: address.state.jurisdiction,
          legalDescription: address.state.legalDescription,
          blockNumber: address.state.blockNumber,
          streetNumber: address.state.streetNumber,
          streetName: address.state.streetName,
          buildingNumber: address.state.buildingNumber,
          floorNumber: address.state.floorNumber,
          lotNumber: address.state.lotNumber,
          suiteNumber: address.state.suiteNumber,
          zip: address.state.zip,
          phase: address.state.phase,
          section: address.state.section,
          community: job.community['name'],
          entityType: job.entityType,
          invoiceBy: job.invoiceBy,
        }

        rule.targetCompletionDate = moment().format('MM-DD-YYYY', job.targetCompletionDate)

        rule.actualCompletionDate = moment().format('MM-DD-YYYY', job.actualCompletionDate)

        rule.dateReceived = moment().format('MM-DD-YYYY', job.dateReceived)

        rule.createdAt = moment().format('MM-DD-YYYY', job.createdAt)

        rule.updatedAt = moment().format('MM-DD-YYYY', job.updatedAt)

        if (coordinatorName) {
          rule.coordinator = coordinatorName.name
        }

        if (departmentName) {
          rule.department = departmentName.name
        }

        if (usernameJobCreated) {
          rule.createdBy = usernameJobCreated.name
        }

        if (usernameJobUpdated) {
          rule.updatedBy = usernameJobUpdated.name
        }

        rule.description = sanitizeHtml(job.description,
            {allowedTags: [],
            allowedAttributes: {}
        })

        rule.projectDescription = sanitizeHtml(details.state.description,
            {allowedTags: [],
            allowedAttributes: {}
        })

        if (builderName) {
          rule.builder = builderName.name
        }

        if (clientName) {
          rule.client = clientName.name
        }

        if (legalSubdivision) {
          rule.legalSubdivision = legalSubdivision.name
        }

        if (planName) {
          rule.planName = assemblePlanNameDisplay(planName)
        }

        rows.push(rule)
      })
      const user = rootState.security.user

      createAndDownloadWorksheet(fileName, tabName, header, rows, user)
    }
  },
  modules: {
    details,
    address
  }
}
